import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'terminal', 'Terminal', [["path",{"d":"M5 7l5 5l-5 5"}],["path",{"d":"M12 19l7 0"}]]);